<script setup lang="ts">
import { computed, type CSSProperties } from "vue";

// Inspired by:
//                  https://loading.io/css/
// (added dynamic size and line width via css)

/**
 * USAGE:
 *
 * Create a wrapper around this control. This spinner will then
 * use the wrappers *width* and *height*.
 *
 * The wrappers *font-size* is used to change the spinners line
 * width.
 *
 * The wrappers *border-color* is used to the the spinners color.
 *
 * e.g.:
 * .spinnerWrapper{
 *   // sets spinner size:
 *   height: 6em;
 *   width: 6em;
 *
 *   // sets spinner line width:
 *   font-size: 6px;
 * }
 */

export type BcSpinnerProps = {
  spinnerColor?: string;
  fontSize?: string;
  width?: string;
  height?: string;
};

const {
  spinnerColor = "#c9c9c9",
  fontSize = "3px",
  width = "24px",
  height = "24px",
} = defineProps<BcSpinnerProps>();

const spinnerStyle = computed<CSSProperties>(() => {
  return {
    "--spinner-color": spinnerColor,
    "--spinner-font-size": fontSize,
    "--spinner-width": width,
    "--spinner-height": height,
  };
});
</script>

<template>
  <div class="bissantzControls spinnerControl" v-bind:style="spinnerStyle">
    <div class="spinnerContianer">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
@import "../styles/components/bc-spinner.less";
</style>
